/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import Button from '@atlaskit/button/custom-theme-button';
import { token } from '@atlaskit/tokens';

import { BranchLabel } from 'src/sections/repository/sections/pull-request/components/branches-and-state.style';

export const MergeButton = styled(Button)<any>({
  marginRight: token('space.100'),
});

export const MergeDialogActions = styled.div({
  justifyContent: 'flex-end',
});

export const MergeErrorMessage = styled.div({
  marginTop: token('space.050'),
  display: 'flex',
  alignItems: 'center',
});

export const ButtonContent = styled.div({
  position: 'relative',
});

export const InnerButtonText = styled.span<{ isDisabled: boolean }>(props =>
  props.isDisabled ? 'visibility: hidden' : ''
);

export const MergeSpinner = styled.span({
  minWidth: '100%',
  height: '100%',
  position: 'absolute',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  paddingTop: token('space.050'),
});

export const RepositoryOrRef = styled(BranchLabel)({
  marginRight: token('space.100'),
  maxWidth: 'inherit',
});

export const CommitMessageInputContainer = styled.div({
  marginTop: token('space.250'),
});
